export const onSortEnd = ({ oldIndex, newIndex }) => ({
  type: "ON_SORT_END",
  oldIndex,
  newIndex,
  meta: {
    mixpanel: {
      event: "images.sort",
    },
  },
});

export const getGUIDSuccess = guid => ({ type: "GET_GUID_SUCCESS", guid });
export const getGUIDFailed = error => ({ type: "GET_GUID_FAILED", error });
export const getGUID = _ => ({ type: "GET_GUID_REQUEST" });

export const handleChoosingImages = images => ({
  type: "HANDLE_CHOOSING_IMGAES",
  images,
  meta: {
    mixpanel: {
      event: "image.choose",
    },
  },
});

export const handleUploadedImage = ({ name, uuid, id }) => ({
  type: "HANDLE_UPLOADED_IMGAE",
  name,
  uuid,
  id,
  meta: {
    mixpanel: {
      event: "image.upload",
    },
  },
});

export const handleUploadedImageError = error => ({
  type: "HANDLE_UPLOADED_IMGAE_ERROR",
  error,
});

export const toggleCoverImage = coverImageId => ({
  type: "TOGGLE_COVER_IMAGE",
  coverImageId,
  meta: {
    mixpanel: {
      event: "cover.toggle",
    },
  },
});

export const updateCaption = (imageId, caption) => ({
  type: "UPDATE_CAPTION",
  imageId,
  caption,
  meta: {
    mixpanel: {
      event: "caption.update",
      props: {
        imageId,
        caption,
      },
    },
  },
});

export const deleteImage = imageId => ({
  type: "DELETE_IMAGE",
  imageId,
  meta: {
    mixpanel: {
      event: "image.delete",
      props: {
        imageId,
      },
    },
  },
});

export const handleInfoChange = changesObj => ({
  type: "HANDLE_INFO_CHANGE",
  changesObj,
  meta: {
    mixpanel: {
      event: "Info.fill",
      props: {
        ...changesObj,
      },
    },
  },
});

export const publish = post => ({
  type: "PUBLISH_REQUEST",
  post,
});

export const publishFailed = (error, post) => ({
  type: "PUBLISH_FAILED",
  error: { ...error, post },
});

export const publishSuccess = post => ({
  type: "PUBLISH_SUCCESS",
  post,
  meta: {
    mixpanel: {
      event: "case.publish",
      props: {
        title: post.title,
        description: post.description,
        caseType: post.caseType,
        imagesCount: post.images.length,
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/scenes/NewCase/actions.js